import { Component, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { AnimatedComponentOnScrollAndResize } from './classes/animated-component-on-scroll-and-resize';
import { ScreenService } from './shared/services/screen.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';

@Component({
    selector: 'app-shapeupspain',
    templateUrl: './app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent extends AnimatedComponentOnScrollAndResize {
    constructor(elementRef: ElementRef,
                screenService: ScreenService,
                @Inject(PLATFORM_ID) platformId: Object,
                private googleAnalyticsService: GoogleAnalyticsService) {
    super(elementRef,
        screenService,
        platformId);
    }
}
